import { ClockCircleOutlined, UserOutlined } from "@ant-design/icons";
import { QueueInformationContainer } from "./styles";
import { Trans, useTranslation } from "react-i18next";
import { getWaitingRoomMessage } from "lib/helpers/getWaitingRoomMessage";
import { useCountdown } from "hooks/useCountdown";
import React from "react";
import meteorite from "views/resources/icons/meteorite.svg";
import rocket from "views/resources/gifs/rocket.gif";

export const QueueInformation = ({
	peopleInQueue,
	waitTime,
	theme,
	office,
}) => {
	const message = getWaitingRoomMessage(peopleInQueue);
	const { t } = useTranslation("waitingRoom");

	const timeForDataRefresh = useCountdown({
		type: "seconds",
		time: 30,
		reset: true,
	});

	const categoryId = office?.category_id;

	return (
		<QueueInformationContainer theme={theme}>
			{theme.queueInfoLogo && (
				<img
					src={theme.queueInfoLogo}
					alt="Logo"
					className="queue-information__logo"
				/>
			)}

			<p className="queue-information__title">
				{categoryId === 33 ? t("subtitle") : office.name}
			</p>
			<span className="queue__main-text">{message}</span>
			<div className="queue__mainIcons-container">
				<img
					src={rocket}
					alt="Rocket icon"
					className="queue__rocket-icon"
				/>
				{peopleInQueue <= 3 && (
					<img src={meteorite} className="queue__meteorite-icon" />
				)}
			</div>

			<div className="queue__infoCards-container">
				<div className="queue__card-info">
					<div className="info__card-icon-container">
						<UserOutlined className="info__card-icon" />
					</div>
					<div className="queue__infoCard-container">
						<span className="queue__quantity-text">
							{peopleInQueue - 1}
						</span>
						<span className="queue__info-text">
							{t("peopleInLine")}
						</span>
					</div>
				</div>
				<div className="queue__card-info">
					<div className="info__card-icon-container">
						<ClockCircleOutlined className="info__card-icon" />
					</div>
					<div className="queue__infoCard-container">
						<span className="queue__quantity-text">{waitTime}</span>
						<span className="queue__info-text">
							{t("waitingMinutes")}
						</span>
					</div>
				</div>
			</div>

			<div className="queue__bottom-info">
				<p className="info__bottom-text">{t("message")}</p>

				<p className="info__light-text">
					<Trans
						t={t}
						i18nKey="infoUpdate"
						components={{ span: <span />, strong: <strong /> }}
						count={timeForDataRefresh}
					/>
				</p>
			</div>
		</QueueInformationContainer>
	);
};
